import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../misc/misc.module';
import { PermissionsPageRoutingModule } from './permissions-routing.module';
import { PermissionsPageComponent } from './permissions.page';

@NgModule({
  declarations: [PermissionsPageComponent],
  imports: [CommonModule, PermissionsPageRoutingModule, MiscModule, IonicModule]
})
export class PermissionsPageModule {}
